import React from "react";

type ArticleStructuredDataProps = {
  headline: string;
  description?: string;
  image: string | null;
  datePublished?: string;
  dateModified?: string;
  author?: string | null;
};

export const ArticleStructuredData = ({
  headline,
  description,
  image,
  datePublished,
  dateModified,
  author,
}: ArticleStructuredDataProps) => {
  console.log(image);

  const data = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    description,
    ...(image && { image: [image] }),
    datePublished,
    dateModified,
    author: {
      "@type": "Person",
      name: author,
    },
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: data }}
    />
  );
};
